<template lang="pug">
.groupPageAndEditor(:class='{openEditor: openEditor}', @dragover='onDragOver($event)')
  .groupPage-container
    template(v-if="hasError")
      .container
        .text-center.tpadding.bigPadding
          p
            i.fa.fa-exclamation-triangle.fa-4x
          h4 {{$t('groupPages.noExistingGroup.title')}}
          br
          br
          p {{$t('groupPages.noExistingGroup.description1')}}
          p
            router-link(:to='{name: "GroupPage"}') {{$t('groupPages.noExistingGroup.description2')}}
    template(v-else)
      template(v-if='!group && user')
        .content-header
          h1
            | {{$t('groupPages.title')}}
            small(v-if="groops.length > 0") {{$t('groupPages.subtitle')}}
          small &nbsp;
          .alert.alert-info.text-muted {{$t('groupPages.description')}}
        select-a-group(v-if="groops.length > 0", @select-group='selectOtherGroup')
        .content-header(v-else)
          .alert.alert-warning.text-muted {{$t('groupPages.noGroup.intro')}}

      
      template(v-if='!group && !shownGroup')
        .content-header
          h1
            | {{$t('groupPages.publicPages.title')}}
            small(v-if="cacheGroupsToExplore.status == STATUS.LOADING")
              i.fa.fa-spin.fa-refresh
              | &nbsp; {{$t('globals.loading')}}
            small(v-if="cacheGroupsToExplore.status == STATUS.LOADED")
              | {{Object.keys(groupsToExplore).length}} {{$t('groupPages.publicPages.groups')}}
          small &nbsp;
          .alert.alert-info.text-muted {{$t('groupPages.publicPages.description')}}
          .text-center
            .card(v-for="group in groupsToExplore", :key="group.id", @click="selectOtherGroup(group)")
              vue-object-img(:object="group")
              .name {{group.id}} - {{group.name}}


      div.groupPage(v-if='group && !hasError')
        .modal(ref='changePictureModal', v-if='openEditor')
          .modal-dialog
            .modal-content
              .modal-header
                button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
                h4.modal-title {{$t('groupPages.page.changeGroupPicture')}}
              .modal-body
                .text-center
                  change-avatar(:object="group", ref='changeAvatar')
        .fixedHeader
          vue-object-img(:object='group')
          h1.name {{group.name}}
        div.introduction
          div.backgroundImage(:style='background', @mouseup="onChangeBackgroundImageClick")
            i.editBtn.fa.fa-picture-o(v-if='openEditor')
            i.editBtn.fa.fa-arrows-v(v-if='openEditor', @mousedown="startMoveBackgroundPicture", :class="{active: movingBackground}")
          vue-object-img(:object='group', v-if="group.hasPicture || openEditor", @click="onProfileImageClick")
          i.editBtn.forProfileImg.fa.fa-picture-o(v-if='openEditor')
          h1.name(@click="onNameClick") {{group.name}}
          h2.punchLine(@click="onPunchLineClick") {{group.pageSentence || (openEditor ? $t('groupPages.page.punchLineDefault') : "")}}
          h3.privacity
            template(v-if='group.isPublic') 
              i.fa.fa-globe
              |  {{$t('groupPages.page.publicGroup')}}
            template(v-else)
              i.fa.fa-lock
              |  {{$t('groupPages.page.privateGroup')}}
          .like(
            v-if="group.page",
            :class='{followed: group.followed}',
            :title='group.followed ? $t("groupPages.followed.yes") : $t("groupPages.followed.no")',
            @click=' toggleFollow', ref="heartContainer")
            i.fa.fa-heart(ref="heart")
            .text(ref="heartText") {{group.page.nbFollowers}} {{$tc("groupPages.followed.fans", group.page.nbFollowers)}} 
            .text(v-if='group.followed') {{$t("groupPages.followed.withYou")}} 
        div.menu(v-if='modules.length > 0')
          ul
            li(v-for='module in modules')
              a(:data-goto="'#' + module.code") 
                | {{$t("groupPages.modules."+module.code+".title")}}
                .badge(v-if='hasBadge(module)') {{module | nb}}
        .blocks
          .block(v-for='module in modules')
            a(:id='module.code')
            group-page-new-member(v-if='module.type == "newMember"', :vue-data='vueData', :module='module', :open-editor="openEditor", :can-edit="canEdit")
            group-page-description(v-if='module.type == "description"', :vue-data='vueData', :module='module', :open-editor="openEditor")
            group-page-pictures(v-if='module.type == "pictures"', :vue-data='vueData', :module='module', :open-editor="openEditor", @askUpload="$refs.uploader.askFiles()")
            group-page-events(v-if='module.type == "events"', :vue-data='vueData', :module='module', :open-editor="openEditor", @update="askGroupPageInfo(true)")
            group-page-audios(v-if='module.type == "audios"', :vue-data='vueData', :module='module', :open-editor="openEditor", @askUpload="$refs.uploader.askFiles()")
            group-page-videos(v-if='module.type == "videos"', :vue-data='vueData', :module='module', :open-editor="openEditor")
            group-page-links(v-if='module.type == "links"', :vue-data='vueData', :module='module', :open-editor="openEditor")
            group-page-nodes(v-if='module.type == "nodes"', :vue-data='vueData', :module='module', :open-editor="openEditor", @askUpload="$refs.uploader.askFiles()", @update="askGroupPageInfo(true)")
            group-page-contact(v-if='module.type == "contact"', :vue-data='vueData', :module='module', :open-editor="openEditor")
            //- vue-grouppage-fanPage(v-if='module.type == "fanPage"', :vue-data='vueData', :module='module', :open-editor="openEditor")
            //- vue-grouppage-blog(v-if='module.type == "blog"', :vue-data='vueData', :module='module')

          .block(v-if='modules.length == 0') 
            .pcenter
              i.fa.fa-refresh.fa-spin.bigIcon
              br
              | {{$t("globals.loading")}}
        .copyright.pcenter © 
          a(href="https://groopus.com") GroopUs.com
          | . Design: GroopUs.com

  .groupPage-editor(v-if='canEdit', :class='{open: openEditor}')
    .toggleEditorBtn(@click=' toggleEditor', title="Vous avez les droits d'édition de cette page")
      template(v-if='openEditor') {{$t('groupPages.page.closeEditor')}}
      i.fa(:class='{"fa-pencil": !openEditor, "fa-times": openEditor}')
  uploader(ref="uploader", @fileUploaded="fileUploaded", :options="uploaderOptions")
      template(slot="file" slot-scope="props")
        .fileUploader
          div
            .pull-right
              span(@click="stopFile(props.fileInfo)")
                template(v-if="props.fileInfo.status == uploaderConsts.UPLOADING")
                  i.fa.fa-stop-circle
                template(v-else)
                  i.fa.fa-times-circle
            | {{props.fileInfo.file.name}}
            template(v-if="props.fileInfo.status == uploaderConsts.ERROR")
              template(v-if="props.fileInfo.response.error === 'NoEnoughSpace'") 
                .label.label-danger {{$t('nodes.uploader.noEnoughSpace')}}
                | &nbsp;&nbsp;&nbsp;
                .btn.btn-xs.btn-success(@click="openGroupAccount", role="button") {{$t('nodes.uploader.addSpaceBtn')}}
              template(v-else)
                .label.label-danger {{$t('nodes.uploader.error')}}
            template(v-if="props.fileInfo.status == uploaderConsts.CANCELED")
              .label.label-warning {{$t('nodes.uploader.cancelled')}}
                
            .progress.m-t-xs.full.progress-striped.active(v-if="props.fileInfo.status == uploaderConsts.UPLOADING")
              .progress-bar.progress-bar-info(:style='{width: props.fileInfo.upload.progress + "%"}' aria-valuemax='100' aria-valuemin='0', :aria-valuenow='props.fileInfo.upload.progress' role='progressbar')
                | {{Math.round(props.fileInfo.upload.progress) }}%
  dropzone(v-if="canEdit", ref="dropzone", :addFileCallback='dropFileCallback')
    template(slot="dropzone")
      strong
        .dragdropfiles
          i.fa.fa-upload
          | {{$t("nodes.dragdropfileshere")}}

</template>
<script>
import Vue from 'Vue'
import {mapGetters} from 'vuex'

import Uploader from '@/tools/Uploader'
import Dropzone from '@/tools/Dropzone'

import $ from 'jquery'
import _ from 'lodash'
import api from '@/utils/api'

import STATUS from '@/utils/status'

import VueObjectImg from '@/components/shared/VueObjectImg'
import SelectAGroup from '@/components/shared/SelectAGroupDiv'

import ChangeAvatar from '@/components/Profile/ChangeAvatar'

import GroupPageNewMember from './GroupPageNewMember'
import GroupPageDescription from './GroupPageDescription'
import GroupPagePictures from './GroupPagePictures'
import GroupPageContact from './GroupPageContact'
import GroupPageEvents from './GroupPageEvents'
import GroupPageVideos from './GroupPageVideos'
import GroupPageAudios from './GroupPageAudios'
import GroupPageNodes from './GroupPageNodes'
import GroupPageLinks from './GroupPageLinks'

import Proposition from '@/components/shared/Proposition'

import 'animate.css/animate.css'

import modalsBus from '@/components/shared/ModalsBus'

export default {
  props: ['object', 'url'],
  data () {
    return {
      cacheData: {
        groupPage: undefined,
        openEditor: false,
        modules: [],
        data: null,
        error: false
      },
      selectedGroup: this.object || null,
      movingBackground: false,
      parallelDelta: 0,
      cacheGroupsToExplore: {
        status: false,
        data: null
      },
      loaded: false,
      STATUS,
      uploaderConsts: Uploader.consts
    }
  },
  components: {
    VueObjectImg,
    SelectAGroup,
    GroupPageNewMember,
    GroupPageDescription,
    GroupPagePictures,
    GroupPageContact,
    GroupPageEvents,
    GroupPageVideos,
    GroupPageAudios,
    GroupPageNodes,
    GroupPageLinks,
    Uploader,
    Dropzone,
    ChangeAvatar
  },
  beforeRouteEnter (to, from, next) {
    next(function (vm) {
      vm.lastAskedGroupInfo = undefined
      vm.lastInspectedRoutePath = undefined
      vm.changeGroupFromUrl(to, true)
    })
  },

  beforeRouteUpdate (to, from, next) {
    next()
    this.lastAskedGroupInfo = undefined
    this.lastInspectedRoutePath = undefined
    this.changeGroupFromUrl(to, false)
  },

  beforeRouteLeave (to, from, next) {
    // if (this.model.groups.indexOf(this.model.selectedGroup) === -1) {
    //   this.model.selectedGroup = null
    // }
    return next()
  },

  mounted () {
    this.changeGroupFromUrl(this.$route, true)
    $('.groupPage-container').on('click', 'a[data-goto]', function () {
      const $el = $($(this).data('goto')).parent()
      $('#body').animate({scrollTop: $el.position().top - 50}, 300)
      setTimeout(function () {
        $el.addClass('animated fadeIn')
        setTimeout(() => $el.removeClass('animated fadeIn')
        , 500)
      }
      , 500)
    })
    $('#body').on('scroll.groupPage', () => {
      requestAnimationFrame(() => {
        // $(".groupPage > .fixedHeader").toggle $("#body").scrollTop() > $(".groupPage > .introduction").height() - 60
        const diff = $('#body').scrollTop() - $('.groupPage > .introduction').height()
        if (diff > -60) {
          $('.groupPage > .fixedHeader').removeClass('hidden')
        } else {
          $('.groupPage > .fixedHeader').addClass('hidden')
        }
        this.parallelDelta = $('#body').scrollTop()
      })
    })
    $('#body').trigger('scroll.groupPage')
    this.onNewInvitation = () => { this.changeGroupFromUrl(this.$route, true, true) }
    this.onUpdateInvitation = (data) => {
      if (data.action === 'refused') {
        this.askGroupPageInfo(true)
      }
    }
    this.$appwireEvents.$on('groups', this.onNewInvitation)
    this.$appwireEvents.$on('invitations', this.onUpdateInvitation)
  },
  destroyed () {
    $('#body').off('scroll.groupPage')
    $('#body').removeClass('publicView')
    this.$store.dispatch('groops/selectAllGroopsIfSelectedIsNotMine')
    this.$appwireEvents.$off('groups', this.onNewInvitation)
    this.$appwireEvents.$off('invitations', this.onUpdateInvitation)
  },
  filters: {
    'hash' (module) {
      return module.code
    },
    'nb' (module) {
      return ((typeof module.nb !== 'undefined') && module.nb) || ((typeof module.items !== 'undefined') && module.items.length)
    }
  },
  computed: {
    ...mapGetters('groops', [
      'isAllGroopsSelected',
      'firstSelectedGroop',
      'getGroupWithId',
      'groops'
    ]),
    ...mapGetters('user', [
      'user',
      'isConnected'
    ]),
    ...mapGetters('search', [
      'searchText',
      'searchObject',
      'searchOpen'
    ]),
    groupsToExplore () {
      if (this.cacheGroupsToExplore.data) {
        return this.cacheGroupsToExplore.data
      }
      this.cacheGroupsToExplore.data = []
      this.cacheGroupsToExplore.status = STATUS.LOADING
      api.get('public/groups', {
        params: {
          toExplore: true
        },
        __canHaveNoToken: true
      }).then((response) => {
        this.cacheGroupsToExplore.data = response.data.publicGroups
        this.cacheGroupsToExplore.status = STATUS.LOADED
      })
      return this.cacheGroupsToExplore.data
    },
    group () {
      if (this.selectedGroup && this.selectedGroup.id === -2) {
        // this.cacheData.error = true
        this.selectedGroup = null
        this.$store.dispatch('groops/selectAllGroops')
      }
      return this.selectedGroup
    },
    background () {
      if ((this.group.pagePicturePourcent == null)) {
        this.$set(this.group, 'pagePicturePourcent', 50)
      }
      const pagePicturePercent = parseInt(this.group.pagePicturePourcent)
      const back = {
        'background-image': `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)),url(${this.pagePicture})`,
        'background-position': `50% calc(${pagePicturePercent}% + ${this.parallelDelta / 2}px)`
      }
      return back
    },
    pagePicture () {
      const picture = this.group.pagePicture
      if (picture != null) {
        return api.getUrl(`file/${picture.id}/download?size=3`, false)
      } else {
        if (this.group.isIndividual) {
          return 'static/grouppages/random/3.jpg'
        } else {
          const images = {
            MUSIC: 'music',
            WORK: 'work',
            SPORT: 'random/1',
            FRIENDSANDFAMILLY: 'friends',
            FREETIME: 'random/1'
          }
          return `static/grouppages/${images[this.group.type]}.jpg`
        }
      }
    },
    canEdit () {
      return this.group && this.group.page && this.group.page.canEdit
    },
    openEditor () {
      return this.cacheData.openEditor
    },
    vueData () {
      return this.cacheData
    },
    modules () {
      this.cacheData.modules = []
      let modules = this.cacheData.modules
      const shownNodes = []
      let data = this.cacheData.data
      if (data === null) {
        return modules
      }
      let module
      if (data.group.autoInscription.method != null && (data.group.autoInscription.method === 'public' || data.group.userInscriptionStatus || this.$route.query.privateKey)) {
        module = {
          type: 'newMember',
          code: 'newMember'
        }
        modules.push(module)
      }
      if (this.openEditor || (data.description && data.description.length > 0)) {
        module = {
          type: 'description',
          description: data.description,
          code: 'description'
        }
        modules.push(module)
      }

      if (this.openEditor || (data.images.length > 0)) {
        module = {
          type: 'pictures',
          items: data.images,
          code: 'pictures'
        }
        for (let img of Array.from(data.images)) {
          shownNodes.push(img)
        }
        modules.push(module)
      }
      if (this.openEditor || (data.audios.length > 0)) {
        module = {
          type: 'audios',
          items: data.audios,
          code: 'audios'
        }
        for (let audio of Array.from(data.audios)) {
          shownNodes.push(audio)
        }
        modules.push(module)
      }
      if (this.openEditor || (data.videos.length > 0)) {
        module = {
          type: 'videos',
          items: data.videos,
          code: 'videos'
        }
        for (let video of Array.from(data.videos)) {
          if (video.extension === ':youtube') {
            shownNodes.push(video)
          }
        }
        modules.push(module)
      }
      if (this.openEditor || (data.links.length > 0)) {
        module = {
          type: 'links',
          items: [],
          code: 'links'
        }
        for (let link of Array.from(data.links)) {
          if (link.extension === ':link') {
            module.items.push({
              src: link.downloadLink + '?size=3',
              extension: link.extension,
              url: link.url
            })
            shownNodes.push(link)
          }
        }
        if (module.items.length > 0) {
          modules.push(module)
        }
      }
      if (this.openEditor || (data.nodes.length > 0)) {
        const nodes = data.nodes.filter(function (node) {
          for (let g of Array.from(shownNodes)) {
            if (node.id === g.id) {
              return false
            }
          }
          return true
        })
        if (this.openEditor || nodes.length > 0) {
          module = {
            type: 'nodes',
            items: [],
            code: 'nodes'
          }
          module.items = nodes
          modules.push(module)
        }
      }
      if (this.openEditor || (data.events.length > 0)) {
        module = {
          type: 'events',
          items: data.events,
          code: 'events'
        }
        modules.push(module)
      }
      module = {
        type: 'contact',
        code: 'contact'
      }
      modules.push(module)
      return modules
    },
    hasError () {
      return this.cacheData.error
    },
    uploaderOptions () {
      let options = {
        autoHideFinished: true,
        url: (file) => {
          return api.getUrl('file')
        },
        params: (file) => {
          let params = {
            group: this.group.id,
            name: file.name,
            public: true
          }
          if (file.fullPath) {
            params.fullPath = file.fullPath
          }
          return params
        }
      }
      return options
    },
    shownGroup () {
      return this.$route.name === 'GroupPageByUrl' || this.$route.params.groupId
    }
  },
  methods: {
    hasBadge (module) {
      return ((typeof module.nb !== 'undefined') && module.nb) || ((typeof module.items !== 'undefined') && module.items.length)
    },

    toggleFollow () {
      if (!this.group) {
        return
      }
      if ((this.user == null)) {
        return
      }
      this.group.followed = !this.group.followed
      if (this.group.followed) {
        // this.animation.onCheck()
        this.group.page.nbFollowers++
      } else {
        this.group.page.nbFollowers--
      }
      return api.post(`public/${this.group.kind}/${this.group.id}/toggleFollow`)
    },

    toggleEditor () {
      this.cacheData.openEditor = !this.cacheData.openEditor
    },

    selectOtherGroup (group, reload = false) {
      if (!group || !this.selectedGroup || this.selectedGroup.id !== group.id) {
        this.cacheData.data = null
      }
      this.selectedGroup = group
      this.$store.dispatch('groops/select', [group])
      this.loaded = true
      // this.$router.push(`/groupPage/${group.id}`)
    },
    onProfileImageClick () {
      $(this.$refs.changePictureModal).modal('show')
      $(this.$refs.changePictureModal).off('hidden.bs.modal').on('hidden.bs.modal', () => {
        this.askGroupPageInfo()
      })
      this.$refs.changeAvatar.askAvatar()
    },

    onChangeBackgroundImageClick () {
      if (!this.movingBackground) {
        if (this.openEditor) {
          var i = document.createElement('input')
          i.type = 'file'
          i.addEventListener('change', (event) => {
            if (i.files.length > 0) {
              this.$refs.uploader.addFile(i.files[0], {
                onFinish: (file) => {
                  api.put(`/public/group/${this.group.id}/infos`, {
                    pagePictureId: file.result.id
                  }).then(() => {
                    this.askGroupPageInfo()
                  })
                }
              })
            }
          })
          i.click()
        }
      }
    },

    onNameClick () {
      if (this.openEditor) {
        const name = prompt('Nouveau nom de groupe ?', this.group.name)
        if (name) {
          this.group.name = name
          api.put(`/public/group/${this.group.id}/infos`, {
            name: name
          })
        }
      }
    },

    onPunchLineClick () {
      if (this.openEditor) {
        const punchLine = prompt('Nouvelle punch line ?', this.group.pageSentence)
        if (punchLine) {
          this.group.pageSentence = punchLine
          api.put(`/public/group/${this.group.id}/infos`, {
            sentence: punchLine
          })
        }
      }
    },
    startMoveBackgroundPicture (event) {
      const startY = event.screenY
      const startPc = this.group.pagePicturePourcent
      this.movingBackground = true
      $('body').on('mousemove.profileBackgroundPictureMove', event => {
        const deltaY = event.screenY - startY
        this.group.pagePicturePourcent = Math.max(0, Math.min(100, startPc - deltaY))
      })
      $('body').on('mouseup.profileBackgroundPictureMove, mouseleave.profileBackgroundPictureMove', event => {
        $('body').off('mousemove.profileBackgroundPictureMove')
        $('body').off('mouseup.profileBackgroundPictureMove, mouseleave.profileBackgroundPictureMove')
        this.movingBackground = false
        return api.put(`public/${this.group.kind}/${this.group.id}/infos`,
          {
            pagePicturePourcent: this.group.pagePicturePourcent
          }).then(() => {
            $.notify(Vue.i18n.t('groupPages.notify.groupUpdated'))
          }).catch(() => {
            $.notify(Vue.i18n.t('globals.error'), 'error')
          })
      })
    },
    askGroupPageInfo (reload = true) {
      if (!this.group) {
        return
      }
      if (!reload && this.lastAskedGroupInfo === this.group.id) {
        return
      }
      this.lastAskedGroupInfo = this.group.id
      api.get(`public/${this.group.kind}/${this.group.id}/infos`, {
        __canHaveNoToken: true,
        params: {
          privateKey: this.$route.query.privateKey
        }
      })
        .then(response => {
          let data = response.data
          this.cacheData.data = data
          this.$set(this.group, 'page', data)
          this.$set(this.group, 'pagePicture', data.group.pagePicture)
          this.$set(this.group, 'pagePicturePourcent', data.group.pagePicturePourcent)
          this.$set(this.group, 'picture', data.group.picture)
          this.$set(this.group, 'followed', data.followed)
          this.$set(this.group, 'autoInscription', data.group.autoInscription)
          // @$nextTick ->
          //  $(".sortable").each ->
          //    sortable = this
          //    Sortable.create sortable,
          //      handle: '.drag-handle'
          //      onSort: (evt) ->
          //        console.log evt, sortable
        })
    },
    changeGroupFromUrl (to, firstAttempt, reload = false) {
      this.cacheData.error = false
      if (!reload && this.lastInspectedRoutePath === this.$route.path) {
        return
      }
      this.lastInspectedRoutePath = this.$route.path
      if (this.$route.name === 'GroupPageByUrl') {
        let url = this.$route.path.substring(1)
        if (!reload && this.group && this.group.url === url) {
          return
        }
        return api.get('/groupWithUrl', {
          __canHaveNoToken: true,
          params: {
            url,
            privateKey: this.$route.query.privateKey
          }
        })
        .then(response => {
          this.selectOtherGroup(response.data.group, reload)
        })
        .catch(response => {
          this.cacheData.error = true
          this.selectedGroup = null
        })
      } else if (to.params.groupId) {
        let groop = this.getGroupWithId(parseInt(to.params.groupId))
        if (groop) {
          this.selectOtherGroup(groop)
        } else {
          // this.model.selectedGroup = null
          if (this.group && this.group.id === parseInt(to.params.groupId)) {
            return
          }
          return api.get(`/public/group/${to.params.groupId}/infos`, {
            __canHaveNoToken: true,
            params: {
              minView: true,
              privateKey: this.$route.query.privateKey
            }
          })
          .then(response => {
            this.selectOtherGroup(response.data.group)
            // this.selectedGroup
          }).catch(() => {
            this.cacheData.error = true
            this.selectedGroup = null
          })
        }
      } else {
        if (firstAttempt) {
          this.selectedGroup = this.firstSelectedGroop
        } else {
          this.$store.dispatch('groops/selectAllGroops')
        }
      }
    },
    sendSearchPropositions () {
      let propositions = []
      if (!this.searchOpen) {
        this.$store.dispatch('search/setPropositions', propositions)
        return
      }
      if (this.searchObject.texts.length > 0) {
        this.$store.dispatch('groops/publicGroopsWithTexts', this.searchObject.texts).then((publicGroups) => {
          _.each(publicGroups, (g) => {
            propositions.push(new Proposition(g.id, {
              textToShow: g.name,
              description: g.description,
              // explanationKey: g.description,
              onSelect: () => {
                this.selectOtherGroup(g)
                this.$store.dispatch('search/setNewText', '')
              }
            }))
          })
        })
      }
      this.$store.dispatch('search/setPropositions', propositions)
    },
    fileUploaded (file) {
      this.askGroupPageInfo()
    },
    onDragOver (event) {
      if (!this.canEdit) {
        return
      }
      event.stopPropagation()
      event.preventDefault()
      event.dataTransfer.dropEffect = 'copy'
      this.$refs.dropzone.open()
    },
    dropFileCallback (file) {
      this.$refs.uploader.addFile(file)
    },
    stopFile (fileInfo) {
      if (fileInfo.status === this.uploaderConsts.UPLOADING) {
        this.$refs.uploader.cancelFile(fileInfo)
      } else {
        this.$refs.uploader.removeFile(fileInfo)
      }
    },
    openGroupAccount () {
      modalsBus.open(modalsBus.modals.OPEN_GROUP_ACCOUNT, this.group)
    }
  },

  watch: {
    group () {
      $('#body').trigger('scroll')
      $('#body').removeClass('publicView')
      this.cacheData.openEditor = false
      if (!this.cacheData.group || !this.group || this.cacheData.group.id !== this.group.id) {
        this.cacheData.data = null
      }
      this.cacheData.group = this.group
      if (!this.group && !this.cacheData.error) {
        this.$router.push('/groupPage')
      } else {
        if (this.group) {
          if (this.group.url) {
            if (this.$route.path === `/groupPage/${this.group.id}` || this.$route.path.toLocaleLowerCase() === `/${this.group.url}`.toLocaleLowerCase()) {
              this.$router.replace({path: `/${this.group.url}`, query: this.$route.query})
            } else {
              this.$router.push({path: `/${this.group.url}`, query: this.$route.query})
            }
          } else {
            this.$router.push({path: `/groupPage/${this.group.id}`, query: this.$route.query})
          }
        }
        $('#body').addClass('publicView')
      }
      this.askGroupPageInfo()
      return this.$nextTick(() => {
        // this.animation = window.animation(this.$refs.heartContainer, this.$refs.heart, this.$refs.heartText)
      })
    },
    firstSelectedGroop () {
      this.selectedGroup = this.firstSelectedGroop
    },
    searchObject () {
      this.sendSearchPropositions()
    },
    searchOpen () {
      this.sendSearchPropositions()
    },
    openEditor () {
      $(this.$refs.changePictureModal).modal('hide')
    }
  }
}
</script>
<style lang="sass">
.pb
  padding-bottom: 20px

.pt
  padding-top: 20px

.groupPageAndEditor
  min-height: 100vh
  position: relative
  .editBtn
    opacity: 0
    position: absolute
    top: 20px
    right: 20px
    width: 50px
    height: 50px
    line-height: 50px
    text-align: center
    background-color: #888
    color: white
    z-index: 4000
    border-radius: 50%
    cursor: pointer
    transition: opacity 0.2s ease
    i
      vertical-align: middle
      font-size: 15px
    &.forProfileImg
      top: 140px
      left: 50%
      transform: translateX(-50%)
      pointer-events: none
    & + .editBtn
      margin-top: 60px
    &:hover
      opacity: 1
    &.fa-arrows-v
      cursor: ns-resize
    &.active
      opacity: 0.3
.groupPage-editor
  .toggleEditorBtn
    position: fixed
    bottom: 20px
    top: auto
    right: 20px
    width: 50px
    height: 50px
    line-height: 50px
    background-color: red
    z-index: 1000
    border-radius: 50%
    color: white
    text-align: center
    cursor: pointer
    i
      font-size: 20px
  &.open .toggleEditorBtn
    background-color: #888
    border-radius: 60px
    width: 200px
    i
      margin-left: 5px



.groupPage-container
  // background-color: white
  min-height: 100vh
  .editBtn
    position: absolute

.groupPage
  min-height: 100vh
  background-color: #fafafa
  padding-bottom: 100px
  .fixedHeader
    position: fixed
    top: 0
    right: 0
    left: 0
    z-index: 1
    background-color: rgba(0,0,0,0.8)
    color: white
    padding-left: 50px
    height: 50px
    transition: margin-top 0.5s ease
    margin-top: 0px
    &.hidden
      margin-top: -100px
      display: block !important
    h1
      font-size: 1.3em
      margin-top: 15px
      text-align: center
      width: calc(100% - 80px)
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
    .profileImage
      float: right
      width: 60px
      height: 60px
      line-height: 60px
      margin-top: 10px
      margin-right: 20px
      box-shadow: 4px 4px 16px rgba(0,0,0,0.3)
  .introduction
    position: relative
    height: 450px
    margin: 0 auto
    .openEditor &
      cursor: pointer
    .backgroundImage
      width: 100%
      height: 100%
      background-color: #333
      -webkit-background-size: cover
      background-size: cover
      repeat: no-repeat 
      background-position: 50% 50%
      -webkit-box-shadow: inset 2000px 2000px 19px 0px rgba(0,0,0,0.1)
      -moz-box-shadow: inset 2000px 2000px 19px 0px rgba(0,0,0,0.1)
      box-shadow: inset 2000px 2000px 19px 0px rgba(0,0,0,0.1)  
      &:hover > .editBtn:not(.active)
        opacity: 1
    .profileImage
      position: absolute
      top: 70px
      left: 50%
      -webkit-transform: translateX(-50%)
      -moz-transform: translateX(-50%)
      transform: translateX(-50%)
      width: 200px
      height: 200px
      line-height: 200px
      font-size: 80px
      box-shadow: 4px 4px 16px rgba(0,0,0,0.5)
      &:hover ~ .editBtn
        opacity: 1
    .name
      position: absolute
      top: 270px
      left: 160px
      color: white 
      font-size: 40px
      font-weight: bolder
    .punchLine
      position: absolute
      top: 365px
      left: 165px
      font-size: 20px
      margin: 0
      color: white
      overflow: hidden
      max-height: 50px
    .privacity
      position: absolute
      top: 340px
      left: 165px
      font-size: 15px
      margin: 0
      color: white
    .name, .punchLine, .privacity
      width: 100%
      left: 0
      text-align: center
      text-shadow: 0px 0px 10px rgba(0,0,0,1)
      transition: text-shadow 0.2s ease
      .openEditor &:hover
        text-shadow: 0px 0px 20px rgba(0,0,0,1)
    .like
      position: absolute
      right: 20px
      top: 370px
      bottom: auto
      color: white
      text-align: center
      cursor: pointer
      border-radius: 50%
      padding: 5px
      text-shadow: 0px 0px 10px rgba(0,0,0,0.5)
      i
        opacity: 0.5
        font-size: 25px
        display: block
      &:hover i, &.followed i
        opacity: 1
      &.followed i
        color: #ff1212
  
  .blocks
    box-shadow: 0px 0px 15px rgba(0,0,0,0.2)
    max-width: 950px
    width: calc(100% - 40px)
    margin: 0 auto 0px auto
    border-radius: 10px

  .block, .menu
    margin: 0 auto
  .block
    animation-duration: 1s
    animation-iteration-count: infinite
    background-color: white
    padding: 30px 20px
    margin: 0 0px
    &:first-child
      margin-top: 40px
      border-top-left-radius: 10px
      border-top-right-radius: 10px
    &:last-child
      border-bottom-left-radius: 10px
      border-bottom-right-radius: 10px
    &:not(:last-child)
      border-bottom: 1px solid #EEE
    @media(min-width: 1020px)
      padding: 30px 60px
    .drag-handle
      cursor: move
    .description
      white-space: pre-line
    .nodes
      min-height: inherit
    .events
      padding-top: 20px
      li
        padding-bottom: 20px
      .address
        font-weight: lighter
      .date
        padding-top: 5px
    .audios
      .duration
        display: inline-block
        width: 120px
    .pictures
      list-style: none
      margin: 0
      padding: 0
      text-align: center
      li
        display: inline-block
        $gap: 5px
        width: calc(100% / 5 - #{2 * $gap})
        padding-bottom: calc(100% / 5 - #{2 * $gap})
        @media(max-width: 900px)
          width: calc(100% / 4 - #{2 * $gap})
          padding-bottom: calc(100% / 4 - #{2 * $gap})
        @media(max-width: 700px)
          width: calc(100% / 3 - #{2 * $gap})
          padding-bottom: calc(100% / 3 - #{2 * $gap})
        @media(max-width: 476px)
          width: calc(100% / 2 - #{2 * $gap})
          padding-bottom: calc(100% / 2 - #{2 * $gap})
        margin: $gap
        background-size: cover
        background-repeat: no-repeat
        background-position: center
        margin-bottom: $gap - 4
        cursor: pointer
        transition: transform 0.2s ease
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.5)
        .groupPageAndEditor.openEditor &
          position: relative
        i
          position: absolute
          top: -5px
          right: -5px
          border-radius: 50%
          width: 30px
          height: 30px
          line-height: 30px
          background-color: white
          box-shadow: 0 0 5px rgba(0,0,0,0.5)
          // & + i
          //   right: -5px


        .groupPageAndEditor:not(.openEditor) &:hover
          transform: scale(1.3)
          transition-delay: 0.1s
          box-shadow: 0 0 16px rgba(0, 0, 0, 0.5)
    .links
      li
        position: relative
        min-height: 30px
        a
          word-break: break-all
      .trash, .drag-handle
        position: absolute
        display: block
        width: 30px
        height: 30px
        line-height: 30px
        top: 0px
        right: 0
        background-color: white
        text-align: center
        border-radius: 50%
        cursor: pointer
        box-shadow: 4px 3px 13px rgba(0, 0, 0, 0.20)
      .drag-handle
        right: 30px

        
    .videos
      list-style: none
      margin: 0
      padding: 0
      li
        position: relative
      li:not(:last-child)
        margin-bottom: 20px
      .trash, .drag-handle
        position: absolute
        top: 0px
        width: 30px
        height: 30px
        line-height: 30px
        background-color: white
        text-align: center
        border-radius: 50%
        cursor: pointer
        transition: font-size 0.3s ease, color 0.3s ease
        box-shadow: 4px 3px 13px rgba(0, 0, 0, 0.20)
        &:hover
          color: red
          font-size: 1.2em
      .trash
        right: 20px
      .drag-handle
        right: 60px
        cursor: move
      .yt, .dm
        position: relative
        img.thumb
          width: 100%
          min-height: 200px
          cursor: pointer
        .videoWrapper
          position: relative
          padding-bottom: 56.25% 
          padding-top: 25px
          height: 0
        iframe
          position: absolute
          top: 0
          left: 0
          width: 100%
          height: 100%
        .fa-play
          color: white
          top: 50%
          left: 50%
          position: absolute
          pointer-events: none
          transition: font-size 0.3s ease, color 0.3s ease
          transform: translateX(-50%) translateY(-50%)
          &:before
            text-shadow: 4px 3px 13px rgba(0, 0, 0, 0.89)
        img.thumb:hover ~ .fa-play
          color: #F00
          font-size: 3em
        & ~ .trash, & ~ .drag-handle
          top: 20px
      


  .menu   
    @media(max-width: 550px)
      display: none
    margin-top: 40px
    text-align: center
    ul
      list-style: none
      li
        display: inline-block
        cursor: pointer
        border-bottom: 2px solid transparent
        transition: border 0.5s ease
        &:hover
          border-bottom-color: #777
        a
          display: inline-block
          padding: 20px
          color: #333
          position: relative
          .badge
            position: absolute
            top: 15px
            right: 5px
            font-size: 10px
            line-height: 15px
            padding: 0px 5px
            border-radius: 50%
            border: 0
            color: #AAA
            background-color: transparent

  .copyright
    color: #888
    margin-top: 30px
    margin-bottom: 50px
@media(max-width: 550px)
  .groupPage
    .introduction
      height: 400px
      .backgroundImage
        height: 200px
        -webkit-box-shadow: none
        -moz-box-shadow: none
        box-shadow: none
      .profileImage
        top: 125px
        width: 150px
        height: 150px
        line-height: 150px
        font-size: 60px
      .name
        font-size: 30px
      .name, .punchLine, .privacity
        color: #333
        text-shadow: none
      .like
        top: 220px
        bottom: auto
        color: #333
        text-shadow: none

</style>
<style lang="sass" scoped>
.uploader
  background-color: white
  position: fixed
  bottom: 10px
  right: 80px
  width: 400px
  max-height: 400px
  overflow: auto
  box-shadow: 0px 0px 10px rgba(0,0,0,0.2)
  .fileUploader
    padding: 15px
    margin-bottom: 5px
.card
  width: 200px
  text-align: center
  background-color: white
  margin: 5px
  display: inline-block
  box-shadow: 5px 5px 5px rgba(0,0,0,0.2)
  padding: 15px
  vertical-align: top
  cursor: pointer
  transition: box-shadow 0.5s ease
  &:hover
    box-shadow: 5px 5px 15px rgba(0,0,0,0.5)
  .profileImage
    height: 150px
    line-height: 150px
    width: 150px
.dragdropfiles
  margin: auto
  text-align: center
  font-size: 2em
  opacity: 0.6

  i
    font-size: 10em
    display: block
</style>



// WEBPACK FOOTER //
// GroupPages.vue?e156d026